import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ChangeVehicleInterstate } from '@makemydeal/dr-activities-change-vehicle';
import { getAppliedVehicle, useSellingVehicleSelector } from '@makemydeal/dr-sales-checkin-store';
import { buildVehicleName } from '@makemydeal/dr-sales-checkin-ui-utils';
import { Accordion } from '@makemydeal/ui-bricks/dist/cox';
import {
    StyledAccordionContainer,
    StyledAccordionSubtitle,
    StyledAccordionTitle,
    StyledVehicleWrapper
} from './DealSetupScreen.style';

export const DealSetupVehicleSection: React.FC<{
    /** Controlled expanded state, owned by the screen so Launch can collapse the accordion. */
    expanded: boolean;
    /** Toggle handler for the accordion header. */
    onToggle: () => void;
}> = ({ expanded, onToggle }) => {
    // Inline actions apply the row selection to `state.vehicle` immediately, so `getAppliedVehicle`
    // is current.
    const selectedVehicle = useSelector(getAppliedVehicle);
    const dealVehicle = useSellingVehicleSelector();

    const appliedVehicle = useSelector(getAppliedVehicle);
    const previousAppliedVehicle = useRef(appliedVehicle);

    useEffect(() => {
        if (previousAppliedVehicle.current === appliedVehicle) {
            return;
        }
        previousAppliedVehicle.current = appliedVehicle;

        if (appliedVehicle.vin || appliedVehicle.chromeStyleId) {
            onToggle();
        }
    }, [appliedVehicle, onToggle]);

    const hasVehicle = !!(selectedVehicle.vin || selectedVehicle.chromeStyleId || dealVehicle.vin);

    const vehicleName =
        buildVehicleName(selectedVehicle.condition, selectedVehicle.year, selectedVehicle.make, selectedVehicle.model) ||
        buildVehicleName(dealVehicle.inventoryType, dealVehicle.year, dealVehicle.make, dealVehicle.model);

    const subtitle =
        !expanded && hasVehicle && vehicleName ? (
            <StyledAccordionSubtitle>Selected : {vehicleName}</StyledAccordionSubtitle>
        ) : undefined;

    return (
        <StyledAccordionContainer>
            <Accordion
                testId="deal-setup-vehicle-accordion"
                justifyContent="space-between"
                useExternalState
                isActive={expanded}
                buttonHandleClick={onToggle}
                title={<StyledAccordionTitle onClick={onToggle}>Vehicle (required)</StyledAccordionTitle>}
                subtitle={subtitle}
                content={
                    <StyledVehicleWrapper>
                        {expanded && <ChangeVehicleInterstate enableConfirmModal={false} forceSmallBreakpoint />}
                    </StyledVehicleWrapper>
                }
            />
        </StyledAccordionContainer>
    );
};
